import { Form, Steps } from 'antd';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-radius: 4px;
    background-color: #e6e6e6;
  }

  > * {
    color: var(--primary-color);
    font-size: 16px;
  }
`;

export const CustomForm = styled(Form)`
  width: 100%;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  margin-top: 16px;
`;

export const StepsContainer = styled(Steps)`
  width: min(400px, 100%);
  margin-bottom: 40px;

  .ant-steps-item-finish .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: var(--primary-color) !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
    background-color: var(--primary-color) !important;
  }

  .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
    border: 2px solid var(--primary-color) !important;
    background-color: #f2f2f2 !important;
  }
`;
